module.exports = __webpack_public_path__ + "static/firebase-b0c12b3217284d8a3cfc7ca8f172b70d.png";